import React, { FC, useEffect, useState } from "react";
import { QuestionProps } from "../../../pages/form";
import { Input } from "antd";
import { useDebouncedCallback } from "use-debounce";
import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import { extractTranslation } from "../../../helpers/formatters";

const { TextArea } = Input;

export const StringQuestion: FC<QuestionProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const { formatMessage } = useIntl();
  const locale = useRouter().locale;

  const stringQuestion = question?.string;
  const stringAnswer = answer?.value?.string?.value;

  const maxCharacters = stringQuestion?.maxCharacters;
  const placeholder =
    extractTranslation(stringQuestion?.placeholder, locale) ||
    formatMessage({ id: "placeholder" });

  const [internalValue, setInternalValue] = useState<string>();

  useEffect(() => {
    if (stringAnswer !== internalValue) {
      setInternalValue(stringAnswer || undefined);
    }
  }, [stringAnswer]);

  const answerDebounced = useDebouncedCallback((value: string | undefined) => {
    onAnswer({
      string: {
        value: value,
      },
    });
  }, 400);

  function onChange(newValue: string | undefined) {
    setInternalValue(newValue);

    answerDebounced(newValue);
  }

  return (
    <div>
      <TextArea
        size={"large"}
        rows={6}
        allowClear={false}
        placeholder={placeholder}
        maxLength={maxCharacters || undefined}
        value={internalValue}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </div>
  );
};
